import {ConfigService} from "vimmi-web-utils/cjs/configService";

const Config = new ConfigService();
export default Config;
